import { twMerge } from "tailwind-merge";
import { bankCardMetadata } from "@features/Budget/budgetConstants";
import { TaxCollectorTypeCheckbox } from "@features/PaymentTaxCollectorSelectModal/components/TaxCollectorTypeCheckbox";
import { type BankName } from "@services/budget/types";

interface IBankButtonProps {
  bankName: BankName;
  className?: string;
  onClick: () => void;
  isSelected: boolean;
}

export const BankButton: React.FC<IBankButtonProps> = (props) => {
  const { bankName, className, onClick, isSelected } = props;

  const metadata = bankCardMetadata[bankName] ?? bankCardMetadata.Default;

  return (
    <button
      onClick={onClick}
      className={twMerge(
        "relative flex min-w-52 items-center gap-3 rounded-lg p-3 outline outline-1 outline-grey-light transition-all",
        isSelected && "outline-2 outline-green-dark",
        className,
      )}
    >
      {metadata.icon && <metadata.icon className="size-12 min-w-12" />}
      <h6>{bankName}</h6>
      <TaxCollectorTypeCheckbox
        className="absolute right-2 top-2 rounded-full border-none checked:bg-green-dark hover:checked:bg-green-dark focus:ring-0 focus:checked:bg-green-dark"
        checked={isSelected}
        readOnly
      />
    </button>
  );
};
